import { Framework7Icons } from "@/types/framework7-icons";
import Icons from "framework7-icons/react/framework7-icons-react.cjs";

interface IconWrapperProps {
  icon: keyof typeof Framework7Icons;
  className?: string;
}

export const FrameworkIcon = ({
  icon,
  className,
  ...props
}: IconWrapperProps) => {
  const IconComponent = Icons[Framework7Icons[icon]];
  return <IconComponent className={className} {...props} />;
};
